export function isSSORedirect() {
  if (window.location.pathname === '/sso/custom/callback') return true

  const url = window.location.toString()
  return url.includes('isLINERedirect=true') || url.includes('isLINERedirect%3Dtrue')
}
